import { motion } from "framer-motion";
import { FOUNDER_IMG } from "@/constants/site";

const DOMAINS = ["International Trade", "Professional Services", "Digital Solutions", "Strategic Partnerships"];

export const Founder = () => (
  <section id="founder" data-testid="founder-section" className="relative overflow-hidden bg-royal-deep py-24 lg:py-32">
    <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_left,rgba(212,175,55,0.06),transparent_50%)]" />
    <div className="relative mx-auto grid max-w-7xl items-center gap-16 px-6 lg:grid-cols-[2fr_3fr] lg:px-10">
      <motion.div
        initial={{ opacity: 0, scale: 0.94 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
        className="relative mx-auto w-full max-w-sm"
      >
        <div className="absolute -inset-4 rounded-2xl border border-gold/25" />
        <div
          className="relative aspect-[4/5] overflow-hidden rounded-xl border border-gold/20"
          data-testid="founder-portrait"
        >
          <img
            src={FOUNDER_IMG}
            alt="Rahul Sharma, Founder & Director of Rayasthaila"
            className="h-full w-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-royal-deep/95 via-royal-deep/10 to-transparent" />
          <div className="absolute bottom-0 left-0 p-6 sm:p-8">
            <p className="font-serif text-2xl font-semibold text-white">Rahul Sharma</p>
            <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.3em] text-gold">Founder & Director</p>
          </div>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
      >
        <p className="font-mono text-[10px] uppercase tracking-[0.35em] text-gold sm:text-xs">Founder & Director</p>
        <h2 className="mt-6 font-serif text-3xl font-medium leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl">
          Rahul Sharma
        </h2>
        <p className="mt-8 border-l-2 border-gold pl-6 font-serif text-lg italic leading-relaxed text-gold-light sm:text-xl">
          "Every border hides an opportunity. Our work is to make it reachable."
        </p>
        <p className="mt-8 text-base leading-relaxed text-slate-300">
          An entrepreneur with experience in building and growing businesses across international trade, professional
          services, and digital solutions, Rahul is passionate about connecting businesses across borders, fostering
          strategic partnerships, and creating opportunities that drive sustainable growth.
        </p>
        <p className="mt-5 text-base leading-relaxed text-slate-400">
          He works with organisations to explore international trade opportunities, identify reliable business
          partners, and facilitate cross-border collaboration across sectors including healthcare, pharmaceuticals,
          medical devices, technology, manufacturing, and professional services.
        </p>
        <div className="mt-10 flex flex-wrap gap-3">
          {DOMAINS.map((d) => (
            <span
              key={d}
              className="rounded-full border border-gold/30 px-4 py-1.5 text-xs uppercase tracking-[0.15em] text-gold-light"
            >
              {d}
            </span>
          ))}
        </div>
      </motion.div>
    </div>
  </section>
);
